import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var ChatMessageAPI = /** @class */ (function () {
    function ChatMessageAPI(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    ChatMessageAPI.initialize = function (basePath, fetchApi) {
        if (!ChatMessageAPI.instance) {
            ChatMessageAPI.instance = new ChatMessageAPI(basePath, fetchApi);
        }
        return ChatMessageAPI.instance;
    };
    ChatMessageAPI.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1ChatMessageApi(new Configuration(config));
    };
    return ChatMessageAPI;
}());
export { ChatMessageAPI };
